export default "__VITE_PUBLIC_ASSET__48ce2d86__"